import BaseApi from './base/BaseApi';

export default class CrmClientApi extends BaseApi {
  static entityName = 'crm_clients';
}
